import { render, staticRenderFns } from "./UosPicker.vue?vue&type=template&id=47e3eb9a"
import script from "./UosPicker.vue?vue&type=script&lang=js"
export * from "./UosPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports